import { AxiosPostBody } from '../../../types/AxiosPost';
import { UserCredentialsType } from '../../../types/types';
import axiosPost from '../axiosPost';

type Args = UserCredentialsType & {
    merchantId: number
};

export const MWDashboardPorCobrarGet = async (arg: Args) => {
    const body: AxiosPostBody = {
        "service": "MWDashboardPorCobrarGet",
        "params": {
            "merchantId": arg.merchantId,
        }
    }

    try {
        const result = await axiosPost('Y', body, arg);
        

        return result.result
    } catch (err) {
        console.log(err)
    }
}